import { isBrowser } from 'ws-scripts/modules/environment';

export const getSpotIconSize = (deviceType) => {
	const screen =
		deviceType === 'DESKTOP' && isBrowser && window.screen?.width > 1440
			? 'HIRES'
			: deviceType;
	return (
		{
			HIRES: '80',
			DESKTOP: '72',
			MOBILE: '64'
		}[screen] ?? '72'
	);
};
